import _isEmpty from 'lodash/isEmpty';
import _keys from 'lodash/keys';

import { OTHER_OPTION } from './components/ContentSuggestionReasonInputs/ContentSuggestionReasonInputs.constants';

export function createContentSuggestionState(suggestionSets) {
  return suggestionSets.reduce((acc, suggestionSet) => {
    const { suggestions } = suggestionSet;

    return {
      ...acc,
      ...suggestions.reduce(
        (setAcc, suggestion) => ({
          ...setAcc,
          [suggestion.id]: {
            reason: '',
            approved: false,
            rejected: false,
            acceptedValue: '',
          },
        }),
        {},
      ),
    };
  }, {});
}

export function approveSuggestion(suggestionReviewStatus, suggestionId) {
  return _keys(suggestionReviewStatus).reduce((acc, id) => {
    const currentSuggestion = suggestionReviewStatus[id];
    const isSelectedSuggestion = +id === suggestionId;

    return {
      ...acc,
      [id]: {
        ...currentSuggestion,
        approved: isSelectedSuggestion ? !currentSuggestion.approved : false,
        rejected: isSelectedSuggestion ? false : currentSuggestion.rejected,
        reason: isSelectedSuggestion ? '' : currentSuggestion.reason,
      },
    };
  }, {});
}

export function rejectSuggestion(suggestionReviewStatus, suggestionId) {
  return _keys(suggestionReviewStatus).reduce((acc, id) => {
    const currentSuggestion = suggestionReviewStatus[id];
    const isSelectedSuggestion = +id === suggestionId;

    return {
      ...acc,
      [id]: {
        ...currentSuggestion,
        rejected: isSelectedSuggestion ? !currentSuggestion.rejected : currentSuggestion.rejected,
        approved: isSelectedSuggestion ? false : currentSuggestion.approved,
        reason: isSelectedSuggestion ? '' : currentSuggestion.reason,
      },
    };
  }, {});
}

export function editSuggestionReason(suggestionReviewStatus, suggestionId, reason) {
  return _keys(suggestionReviewStatus).reduce((acc, id) => {
    const currentSuggestion = suggestionReviewStatus[id];
    const isSelectedSuggestion = +id === suggestionId;

    return {
      ...acc,
      [id]: {
        ...currentSuggestion,
        reason: isSelectedSuggestion ? reason : currentSuggestion.reason,
      },
    };
  }, {});
}

export function editSuggestionAcceptedValue(suggestionReviewStatus, suggestionId, acceptedValue) {
  return _keys(suggestionReviewStatus).reduce((acc, id) => {
    const currentSuggestion = suggestionReviewStatus[id];
    const isSelectedSuggestion = +id === suggestionId;

    return {
      ...acc,
      [id]: {
        ...currentSuggestion,
        acceptedValue: isSelectedSuggestion ? acceptedValue : currentSuggestion.acceptedValue,
      },
    };
  }, {});
}

export function isAnySuggestionReviewed(suggestionReviewStatus) {
  return _keys(suggestionReviewStatus).some(
    (id) => suggestionReviewStatus[id].approved || suggestionReviewStatus[id].rejected,
  );
}

export function validateSuggestionReviewStatus(suggestionReviewStatus, isAdmin) {
  const errors = [];

  const suggestionReviewed = isAnySuggestionReviewed(suggestionReviewStatus);

  if (!suggestionReviewed) {
    errors.push('No suggestions reviewed. Please review at least one suggestion.');
    return errors;
  }

  const approvedCount = _keys(suggestionReviewStatus).filter(
    (id) => suggestionReviewStatus[id].approved,
  ).length;

  if (approvedCount > 1) {
    errors.push('Only one suggestion can be approved at a time.');
    return errors;
  }

  return _keys(suggestionReviewStatus).reduce((acc, suggestionId) => {
    const { approved, rejected, reason } = suggestionReviewStatus[suggestionId];
    const noReason = _isEmpty(reason);
    const isOtherOption = reason === OTHER_OPTION;

    if (approved && noReason) {
      if (isAdmin) {
        acc.push(`Suggestion with id '${suggestionId}' requires a reason for approval`);
      }
    }

    if (rejected && noReason) {
      acc.push(`Suggestion with id '${suggestionId}' requires a reason for rejection`);
    }

    if (rejected && isAdmin && isOtherOption) {
      acc.push(`Suggestion with id '${suggestionId}' requires further detail for rejection`);
    }

    return acc;
  }, errors);
}
